import { getFormattedLanguageShortName } from 'utils/helpers'

import {
  CAMPAIGN_TYPES,
  DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
  DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
  DELIVERY,
  LEVEL_VALUES,
  PARTICIPANTS_EXCLUDE_FILTER_VALUES,
  SEND_REMINDER_EVERY_X_BUSINESS_DAYS_VALUES,
} from 'containers/AwarenessCenter/constants'

const typeKey = 'AwarenessCenter/WizardSimulationCampaign'

export const CHANGE_SELECTED_LOCALE_IDS = `${typeKey}/CHANGE_SELECTED_LOCALE_IDS`
export const CHANGE_LOCALES_BY_PROFILES = `${typeKey}/CHANGE_LOCALES_BY_PROFILES`

export const getSelectedLanguages = ({
  campaignType,
  defaultLocaleId,
  enabledLanguages,
  selectedLocaleIds,
}) => {
  if (campaignType !== CAMPAIGN_TYPES.SIMULATION || !defaultLocaleId) return []

  const languages = [
    getFormattedLanguageShortName(
      enabledLanguages.find(({ id }) => id === defaultLocaleId)?.short_name
    ),
  ]

  selectedLocaleIds.forEach((locale) => {
    const language = enabledLanguages.find(({ id }) => id === locale)

    if (language && !languages.includes(getFormattedLanguageShortName(language?.short_name))) {
      languages.push(getFormattedLanguageShortName(language?.short_name))
    }
  })

  return languages
}

export const getDefaultLocalById = (locales, defaultLocaleId) =>
  locales.find(({ id }) => id === defaultLocaleId)

export const DEFAULT_SIMULATION_PROPERTIES = {
  randomizedScenarios: true, // sending type
  sendAllWeek: true,
  sendReminderEveryXBusinessDays: SEND_REMINDER_EVERY_X_BUSINESS_DAYS_VALUES.CHECKED,
  sendCampaignSummaryToCampaignReportRecipients: true,
  sendCampaignFailedEmail: false,
  sendManagerReportEveryXDays: null,
  managerReportRemindersThreshold: DEFAULT_MANAGER_REPORT_REMINDERS_THRESHOLD,
  managerReportDayOfWeek: DEFAULT_MANAGER_REPORT_DAY_OF_WEEK,
}

export const DEFAULT_SIMULATION_CAMPAIGN_OBJECT = {
  // id: null,
  participants: {
    page: 1,
    selectorLoader: false,
    modalLoader: false,
    error: null,
    modalSearch: '',
    excludeFilter: PARTICIPANTS_EXCLUDE_FILTER_VALUES.INCLUDED,
    included: {},
    excluded: {},
    items: [],
    meta: {
      awarenessLevels: {
        [LEVEL_VALUES.BEGINNER_LEVEL]: 0,
        [LEVEL_VALUES.MID_LEVEL]: 0,
        [LEVEL_VALUES.EXPERT_LEVEL]: 0,
      },
      localeIds: [],
      count: 0,
    },
    includedSelectionIds: [],
    excludedSelectionIds: [],
  },
  leveledScenarios: !DEFAULT_SIMULATION_PROPERTIES.randomizedScenarios, // sending type
  delivery: DELIVERY.EMAIL,
  selectedScenarios: [],
  selectedLandingPage: {},
  selectedTrainingVideo: [],
  // NOTE: getSimulationCampaignLaunchProperties() changed to null if form of active period is not valid
  sendingDays: null,
  selectedLocaleIds: [],
  localesByProfiles: false,
  trainingReminders: [],
  notifications: [],
  ...DEFAULT_SIMULATION_PROPERTIES,
}

export const MAX_TRAINING_REMINDERS = 10
